export const navigationData = [
	{ title: 'Аренда', path: '/rent', id: 'rent' },
	{ title: 'Продажа', path: '/sale', id: 'sale' },
	{ title: 'Ипотека', path: '/mortgage', id: 'mortgage' },
	{ title: 'Об агенстве', path: '/aboutAgency', id: 'aboutAgency' },
	{ title: 'Вопросы', path: '/Questions' },
	{ title: 'Контакты', path: '#' }
];
